'use client'
import { Box, Skeleton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useTranslations } from 'next-intl'
import { BlogItem } from './BlogItem'
const useXlScreenDown = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('xl'))
}
export const HottestBlogs = ({ children, data }: { children?: React.ReactNode; data: IBlogPost[] }) => {
  const t = useTranslations()
  const isXlScreenDown = useXlScreenDown()

  return (
    <Stack spacing={2}>
      <Typography
        variant="h3"
        sx={{
          fontSize: 20,
          fontWeight: 700,
          // color: theme.palette.secondary.main,
          textTransform: 'uppercase',
        }}
      >
        {t('TIN HOT NHẤT TUẦN QUA')}
      </Typography>
      <Stack spacing={2}>
        {data?.map((blog) => (
          <BlogItem
            sx={{ flexDirection: { md: 'column', lg: 'row', xs: 'row' } }}
            blogImageProps={{ sx: { maxWidth: { lg: '139px', md: '100%', xs: '139px' }, aspectRatio: {md: "139/104"}, objectFit: "cover" } }}
            key={blog?.post_id}
            blogContentProps={{ hideDescription: true }}
            blog={blog}
          />
        ))}
      </Stack>

      {isXlScreenDown && children}
    </Stack>
  )
}

export const LoadingBlog = () => {
  return (
    <Stack spacing={2} direction={'row'}>
      <Skeleton variant="rectangular" width={210} height={118} />
      <Box sx={{ pt: 0.5, width: '100%' }}>
        <Skeleton />
        <Skeleton />
        <Skeleton width="60%" />
      </Box>
    </Stack>
  )
}
